import $ from 'jquery';

export default {

	init() {

		$('[id^=accordion-header]').click(function(e) {

				const uniqueId = $(this).data('id');
				const expanded = eval($(this).attr('aria-expanded'));

				$(this).attr('aria-expanded', expanded ? "false" : "true");

				$('#sign-' + uniqueId).find('.js-accordion-sign').toggle();
				$('#accordion-panel-' + uniqueId).slideToggle();

		});

	}

};
